import { render, staticRenderFns } from "./SearchResultsPage.vue?vue&type=template&id=5ecb2820&scoped=true"
import script from "./SearchResultsPage.vue?vue&type=script&lang=js"
export * from "./SearchResultsPage.vue?vue&type=script&lang=js"
import style0 from "./SearchResultsPage.vue?vue&type=style&index=0&id=5ecb2820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecb2820",
  null
  
)

export default component.exports